import type { Reducer, Slice } from '@reduxjs/toolkit';
import type { Reducers, InitialState } from './allSlices.generated';

type SliceModule = {
  default: Reducer;
  initialState: Record<string, unknown>;
  slice: Slice;
};

const allSlices: Record<string, Slice> = {};
const states: Record<string, unknown> = {};
const reducers: Record<string, Reducer> = {};

const sliceModules = import.meta.glob<SliceModule>('./**/*-slice.{js,ts}', {
  eager: true
});

function importAll(r: typeof sliceModules) {
  Object.entries(r).forEach(([, module]) => {
    const typedModule = module as {
      default: Reducer;
      initialState: unknown;
      slice: Slice;
    };
    const { initialState: sliceInitialState, slice } = typedModule;

    states[slice.name] = sliceInitialState;
    allSlices[slice.name] = slice;
    reducers[slice.name] = slice.reducer;
  });
}

importAll(sliceModules);

export const allReducers: Reducers = reducers as Reducers;
export const initialState: InitialState = states as InitialState;

export { allSlices };
